import React from 'react'
import {AuthLogin} from '../../containers'

export default function AuthBaseScreen() {
  return <AuthLogin />
}
